import React from "react";
import { useDropzone, DropzoneOptions, DropEvent } from "react-dropzone";

// Icons
import UploadIcon from "assets/Icon_Upload.png";
import WarningIcon from "assets/Icon_Warning.png";

type DropzoneProps = {
  children?(isDragActive: boolean): React.ReactNode;
  uploadedFile?: File;
  onDrop<T extends File>(
    acceptedFiles: T[],
    rejectedFiles: T[],
    event: DropEvent
  ): void;
  dropzoneOptions?: DropzoneOptions;
  dropzoneTitle?: string;
  showWarningMessage?: string | null | undefined;
  // showWarningMessage?: boolean;
  name: string;
  viewOnly?: boolean;
  fileType?: string;
};

type Props = DropzoneProps;

const Dropzone: React.FC<Props> = ({
  uploadedFile,
  dropzoneOptions,
  children,
  name,
  onDrop,
  dropzoneTitle,
  showWarningMessage = undefined,
  viewOnly,
  fileType,
}) => {
  const [imageBase64, setImageBase64] = React.useState<string>("");

  if (uploadedFile) {
    if (isImage(uploadedFile)) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const imageBase64 = reader.result;
        setImageBase64(imageBase64 as string);
      };

      reader.readAsDataURL(uploadedFile);
    } else {
      // non image file
    }
  }

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    ...dropzoneOptions,
    onDrop,
    disabled: viewOnly,
  });

  return (
    <div
      className={uploadedFile ? "Dropzone Disabled" : "Dropzone"}
      {...getRootProps()}
    >
      {/* If no files uploaded */}
      {!uploadedFile && !showWarningMessage && (
        <>
          <input
            {...getInputProps({
              accept: fileType ? fileType : undefined,
              multiple: false,
              name: name,
            })}
          />
          {children ? (
            children(isDragActive)
          ) : (
            <>
              <img className="Icon" src={UploadIcon} alt="Upload" />
              <p className="Bold">
                {dropzoneTitle ? dropzoneTitle : "File Upload"}
              </p>
              {isDragActive ? (
                <p>Drop here to upload!</p>
              ) : (
                <p>Click or Drag to Upload</p>
              )}
            </>
          )}
        </>
      )}

      {/* If file uploaded, display it */}
      {uploadedFile &&
        (isImage(uploadedFile) ? (
          <img src={imageBase64} />
        ) : (
          <p>{uploadedFile.name}</p>
        ))}
      {/* {uploadedFile && fileType && fileType === "image" ? (
        <img
          className="UploadedImage"
          src={imageBase64}
          alt={uploadedFile.name ? uploadedFile.name : "Uploaded file preview"}
        />
      ) : uploadedFile && fileType && fileType !== "text/csv" ? (
        <p>{uploadedFile.name ? uploadedFile.name : ""}</p>
      ) : null} */}

      {/* Warning message - only upload one file */}
      {showWarningMessage && (
        <span className="WarningMessage">
          <img className="WarningIcon" src={WarningIcon} alt="Warning" />
          Please only upload one file
        </span>
      )}
    </div>
  );
};

export { Dropzone };

// Helpers
const isImage = (file: File) => file.type.search("image") > -1;
